module.exports = __webpack_public_path__ + "img/aiHello.ef70d6dc.png";